export function doFB() {
  openUrl("https://www.facebook.com/HiTRUSTtw");
}

export function doYT() {
  openUrl("https://www.youtube.com/@HiTRUST-taiwan");
}

export function doIG() {
  openUrl("https://www.instagram.com/hitrustpay/");
}

export function doLine() {
  openUrl("https://line.me/R/ti/p/@tej5354x");
}

export function doLinkedIn() {
  openUrl("https://tw.linkedin.com/company/hitrust");
}

function openUrl(url) {
  window.open(url, "_blank");
}
